import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalProps {
  type: 'terms' | 'privacy';
  onClose: () => void;
}
export function Legal({
  type,
  onClose
}: LegalProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-50 bg-[#0a0a0a] overflow-y-auto" data-id="element-157">
      <div className="max-w-3xl mx-auto px-6 py-12" data-id="element-158">
        <div className="flex items-center justify-between mb-12" data-id="element-159">
          <h1 className="text-2xl md:text-3xl font-black text-white" data-id="element-160">
            {type === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
          </h1>
          <button onClick={onClose} className="text-gray-500 hover:text-white transition-colors p-2" aria-label="Cerrar" data-id="element-161">
            <X size={24} data-id="element-162" />
          </button>
        </div>

        <div className="prose prose-invert prose-sm max-w-none space-y-8 text-gray-300 leading-relaxed" data-id="element-163">
          <p className="text-gray-500 text-sm" data-id="element-164">
            Última actualización:{' '}
            {new Date().toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })}
          </p>

          {type === 'terms' ? <TermsContent data-id="element-165" /> : <PrivacyContent data-id="element-166" />}
        </div>

        <div className="mt-16 pt-8 border-t border-[#222]" data-id="element-167">
          <button onClick={onClose} className="text-[#84cc16] hover:underline text-sm font-medium" data-id="element-168">
            ← Volver a la página principal
          </button>
        </div>
      </div>
    </motion.div>;
}
function TermsContent() {
  return <>
      <section data-id="element-169">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-170">
          1. Información general
        </h2>
        <p data-id="element-171">
          Estos Términos y Condiciones regulan la compra y uso del producto
          digital
          <strong className="text-white" data-id="element-172"> "Ingresos Digitales Atómicos"</strong>
          , un ebook en formato digital que enseña un método para monetizar
          redes sociales mediante el sistema Motor 3-Loop (Contenido Prueba →
          Puente a Oferta → Activo de Conversión).
        </p>
        <p className="mt-2" data-id="element-173">
          Al realizar la compra, aceptas estos términos en su totalidad.
        </p>
      </section>

      <section data-id="element-174">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-175">
          2. Producto digital
        </h2>
        <p data-id="element-176">
          "Ingresos Digitales Atómicos" es un ebook descargable que incluye:
        </p>
        <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-177">
          <li data-id="element-178">
            El mapa de monetización (afiliados, UGC, activo propio simple)
          </li>
          <li data-id="element-179">El Motor 3-Loop explicado con ejemplos prácticos</li>
          <li data-id="element-180">
            Prompts atómicos para hooks, guiones, carruseles y respuestas por DM
          </li>
          <li data-id="element-181">Plan operativo de 30 días con horarios y cadencia</li>
          <li data-id="element-182">Biblioteca de ideas y diagnóstico de optimización</li>
        </ul>
        <p className="mt-2" data-id="element-183">
          El acceso al producto es inmediato tras la confirmación del pago y es
          de por vida.
        </p>
      </section>

      <section data-id="element-184">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-185">
          3. Política de reembolso
        </h2>
        <p data-id="element-186">
          Debido a la naturaleza digital del producto y su entrega inmediata,{' '}
          <strong className="text-white" data-id="element-187">no se ofrecen reembolsos</strong> una
          vez completada la descarga. Te recomendamos leer toda la información
          de esta página antes de comprar.
        </p>
      </section>

      <section data-id="element-188">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-189">
          4. Propiedad intelectual
        </h2>
        <p data-id="element-190">
          Todo el contenido de "Ingresos Digitales Atómicos" — incluyendo
          textos, prompts, guiones, el sistema Motor 3-Loop y la metodología
          descrita — es propiedad intelectual del autor.
        </p>
        <p className="mt-2" data-id="element-191">
          Queda prohibida la reproducción, distribución, reventa o modificación
          del contenido sin autorización expresa por escrito.
        </p>
      </section>

      <section data-id="element-192">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-193">5. Uso permitido</h2>
        <p data-id="element-194">La compra te otorga una licencia personal e intransferible para:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-195">
          <li data-id="element-196">
            Leer y aplicar el contenido en tu propia estrategia de redes
            sociales
          </li>
          <li data-id="element-197">Usar los prompts y guiones para crear tu propio contenido</li>
          <li data-id="element-198">
            Implementar el Motor 3-Loop en tus cuentas y proyectos personales
          </li>
        </ul>
        <p className="mt-2" data-id="element-199">
          <strong className="text-white" data-id="element-200">No está permitido</strong> compartir,
          revender, regalar o distribuir el ebook a terceros de ninguna forma.
        </p>
      </section>

      <section data-id="element-201">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-202">
          6. Descargo de responsabilidad sobre resultados
        </h2>
        <p data-id="element-203">
          "Ingresos Digitales Atómicos" proporciona un sistema y herramientas
          para monetizar redes sociales. Sin embargo,{' '}
          <strong className="text-white" data-id="element-204">
            los resultados dependen enteramente de tu ejecución
          </strong>
          , constancia, nicho y mercado.
        </p>
        <p className="mt-2" data-id="element-205">
          No garantizamos ingresos específicos ni resultados financieros. Los
          testimonios y ejemplos representan experiencias individuales y no
          constituyen una promesa de ganancias.
        </p>
      </section>

      <section data-id="element-206">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-207">7. Modificaciones</h2>
        <p data-id="element-208">
          Nos reservamos el derecho de actualizar estos términos. Los cambios
          serán efectivos desde su publicación en esta página. Te recomendamos
          revisarlos periódicamente.
        </p>
      </section>
    </>;
}
function PrivacyContent() {
  return <>
      <section data-id="element-209">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-210">
          1. Información que recopilamos
        </h2>
        <p data-id="element-211">
          Al comprar{' '}
          <strong className="text-white" data-id="element-212">"Ingresos Digitales Atómicos"</strong>,
          recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto:
        </p>
        <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-213">
          <li data-id="element-214">
            <strong className="text-white" data-id="element-215">Correo electrónico:</strong> para
            enviarte el enlace de descarga y comunicaciones relacionadas con tu
            compra
          </li>
          <li data-id="element-216">
            <strong className="text-white" data-id="element-217">Datos de pago:</strong> procesados de
            forma segura a través de nuestro proveedor de pagos (no almacenamos
            datos de tarjeta)
          </li>
          <li data-id="element-218">
            <strong className="text-white" data-id="element-219">Nombre (opcional):</strong> si lo
            proporcionas al momento de la compra
          </li>
        </ul>
      </section>

      <section data-id="element-220">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-221">
          2. Uso de la información
        </h2>
        <p data-id="element-222">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-223">
          <li data-id="element-224">Procesar y confirmar tu compra del ebook</li>
          <li data-id="element-225">
            Enviarte el enlace de descarga de "Ingresos Digitales Atómicos"
          </li>
          <li data-id="element-226">Comunicarte actualizaciones del producto (si las hubiera)</li>
          <li data-id="element-227">Responder a consultas de soporte relacionadas con tu compra</li>
        </ul>
        <p className="mt-2" data-id="element-228">
          <strong className="text-white" data-id="element-229">
            No vendemos, alquilamos ni compartimos
          </strong>{' '}
          tu información personal con terceros para fines de marketing.
        </p>
      </section>

      <section data-id="element-230">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-231">
          3. Protección de datos
        </h2>
        <p data-id="element-232">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal. Los pagos se procesan a través de plataformas
          seguras con cifrado SSL.
        </p>
      </section>

      <section data-id="element-233">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-234">
          4. Cookies y análisis
        </h2>
        <p data-id="element-235">
          Esta página puede utilizar cookies básicas y herramientas de análisis
          para mejorar la experiencia del usuario y entender cómo los visitantes
          interactúan con el contenido. No se utilizan cookies para rastreo
          publicitario de terceros.
        </p>
      </section>

      <section data-id="element-236">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-237">5. Tus derechos</h2>
        <p data-id="element-238">Tienes derecho a:</p>
        <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-239">
          <li data-id="element-240">Solicitar acceso a los datos personales que tenemos sobre ti</li>
          <li data-id="element-241">Solicitar la corrección o eliminación de tus datos</li>
          <li data-id="element-242">
            Darte de baja de comunicaciones por correo electrónico en cualquier
            momento
          </li>
        </ul>
        <p className="mt-2" data-id="element-243">
          Para ejercer cualquiera de estos derechos, contáctanos directamente
          por correo electrónico.
        </p>
      </section>

      <section data-id="element-244">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-245">
          6. Retención de datos
        </h2>
        <p data-id="element-246">
          Conservamos tu información de compra durante el tiempo necesario para
          cumplir con nuestras obligaciones legales y brindarte soporte. Puedes
          solicitar la eliminación de tus datos en cualquier momento.
        </p>
      </section>

      <section data-id="element-247">
        <h2 className="text-xl font-bold text-white mb-3" data-id="element-248">
          7. Cambios en esta política
        </h2>
        <p data-id="element-249">
          Podemos actualizar esta Política de Privacidad ocasionalmente. Los
          cambios se publicarán en esta página con la fecha de actualización
          correspondiente.
        </p>
      </section>
    </>;
}